import {Card} from 'platform/components';
import {Box} from 'platform/foundation';

import {useCallback} from 'react';

import i18n from '@dms/i18n';
import {CommunicationActivityLogDatagrid, Main} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

import {QueryFilterObject} from 'features/eag-grid';

export function CustomerEmailActivityLogs() {
  const {id} = useRequiredParams();

  const emailActivityLogQueryModifier = useCallback(
    (filter: QueryFilterObject) => ({...filter, customerId: [id], recordId: undefined}),
    [id]
  );

  return (
    <Box flexGrow={1}>
      <Main isFullHeight>
        <Card
          title={i18n.t('general.labels.emailActivityLogs')}
          isFullHeight
          key="email-activity-logs-datagrid"
        >
          <CommunicationActivityLogDatagrid
            queryModifier={emailActivityLogQueryModifier}
            presetInstanceId="customer-email-activity-logs"
            data-testid="customer-email-activity-logs-datagrid"
          />
        </Card>
      </Main>
    </Box>
  );
}
